var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('v-slide-x-reverse-transition',_vm._l((_vm.basketMessages),function(item){return _c('Notification',_vm._b({key:item.id,attrs:{"transition":"v-slide-x-transition","full-width":true},on:{"remove":_vm.removeMessage}},'Notification',item,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }